<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yYwXDG/tc-custom/9781960332639.jpg?1716663164957" alt="This image is the cover for the book Wrecking Crew"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wrecking Crew
      </h1>
      <p class="bookDescription body article font2">
        <b>An in-depth true crime study of the case made famous in Netflix’s <i>Making a Murderer</i>, the case against Steven Avery, and the work to free him.</b><br/><br/><b>Updated Fifth Anniversary Edition Including Exclusive Interview with Steven Avery</b><br/><br/>In 2016–17, while working for the <i>USA Today</i> Network’s Wisconsin Investigative Team, author John Ferak wrote dozens of articles examining the murder case against Steven Avery, who had already beaten one wrongful conviction only to be charged again with the murder of Teresa Halbach in 2005. This case captured global attention through the Netflix documentary <i>Making a Murderer</i>.<br/><br/>In this anniversary edition of <b><i>Wrecking Crew:</i> <i>Demolishing the Case Against Steven Avery</i></b>, Ferak not only lays out in meticulous detail the post-conviction strategy of Kathleen Zellner, the high-profile, high-octane lawyer fighting to free Avery but also includes a new “Five Years Later” section. This update provides fresh insights and developments in Avery’s ongoing legal battle.<br/><br/>Additionally, this special edition features an exclusive epilogue: a <b>November 2023 interview with Steven Avery</b>. For this book, Zellner, arguably America’s most successful wrongful conviction attorney, granted Ferak unprecedented access to the exhaustive pro bono efforts she and her small suburban Chicago law firm have invested in a man she believes to be wrongfully ensnared by Manitowoc County’s unscrupulous justice system. This anniversary edition offers new revelations and a comprehensive look at a case that continues to stir public debate and demand justice.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Ferak
      </h2>
      
      <p class="authorDescription body article">John Ferak is an award-winning investigative journalist with the USA TODAY NETWORK's Wisconsin Investigative Team based in Appleton, Wisconsin. He is the lead investigative reporter chronicling the Steven Avery murder case, the case featured in the Netflix documentary "Making a Murderer." Ferak's books, DIXIE'S LAST STAND and BODY OF PROOF were true-crime best-sellers for WildBlue Press. His first book, BLOODY LIES: A CSI SCANDAL IN THE HEARTLAND, won a national award.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WildBlue Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?37f4dde6